import { matchPath } from "react-router";
import { buildKennung, ohneIds } from "../../api/nutzung";
import type { Welt } from "../../welt/einstellungen";

/** W82 Beta-W: was die App selbst zur Rückmeldung einträgt (Fußtext RM19). `seite` ist das Muster der Seite hinter dem Blatt
 *  ohne Kennungen (`ohneIds`), nur aus den Zeichen, die der Server nimmt, höchstens 80 lang (sonst 422 und die ganze
 *  Rückmeldung ginge nicht ein). Kein `geraet`: Browser und System leitet der Server aus dem User-Agent ab (§ 25 TDDDG). */
export type RueckmeldungKontext = {
  plattform: "web";
  build: string;
  seite: string;
  fassung: Welt["fassung"];
  palette: Welt["palette"];
  praesenz: Welt["praesenz"];
};

export function seiteOhneIds(pfad: string): string {
  return ohneIds(pfad || "/")
    .replace(/[^A-Za-z0-9.:/{}_ -]/g, "_")
    .slice(0, 80);
}

export function rueckmeldungKontext(pfad: string, welt: Welt): RueckmeldungKontext {
  return { plattform: "web", build: buildKennung(), seite: seiteOhneIds(pfad), fassung: welt.fassung, palette: welt.palette, praesenz: welt.praesenz };
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** W82 Beta-W2 (Vertrag Beta-S2 Abschnitt 10): die ID des Briefs, wenn die Seite hinter dem Blatt die Dokumentansicht
 *  `/dokument/:id` ist und die ID eine UUID; sonst `null` (Start, Listen wie `/blaettern`, Akten, Einstellungen, Betrieb). */
export function briefHinter(pfad: string): string | null {
  const id = matchPath("/dokument/:id", pfad)?.params.id;
  return id && UUID.test(id) ? id : null;
}

/** Der Körper von `POST /api/rueckmeldungen` (multipart): genau diese Felder, `bild` nur mit Bildschirmfoto, `dokument_id`
 *  (Text ohne Dateinamen) nur aus einer Dokumentansicht. */
export function rueckmeldungFormular(daten: {
  kennung: string;
  text: string;
  kontext: RueckmeldungKontext;
  bild: Blob | null;
  dokumentId?: string | null;
}): FormData {
  const f = new FormData();
  f.append("kennung", daten.kennung);
  f.append("text", daten.text);
  f.append("plattform", daten.kontext.plattform);
  f.append("build", daten.kontext.build);
  f.append("seite", daten.kontext.seite);
  f.append("fassung", daten.kontext.fassung);
  f.append("palette", daten.kontext.palette);
  f.append("praesenz", daten.kontext.praesenz);
  if (daten.dokumentId) f.append("dokument_id", daten.dokumentId);
  if (daten.bild) f.append("bild", daten.bild, "bildschirmfoto.jpg");
  return f;
}
